import { UseQueryResult } from "react-query";

import { Loader } from "ebs-design";

import models from "@aeo/core/models";
import { UsePaginationResult } from "@aeo/core/hooks";

import { AlertErrors, Table, TableProps, Pagination, Flex } from ".";

export interface QueryTableProps<RecordType> extends TableProps<RecordType> {
  query: UseQueryResult<models.WithResults<RecordType>>;
  columns: TableProps<RecordType>["columns"]; // required
  pagination?: UsePaginationResult;
  pageSizeChoice?: number[];
}

export const QueryTable = <RecordType,>({
  query,
  pagination,
  pageSizeChoice,
  ...tableProps
}: QueryTableProps<RecordType>) => {
  return (
    <>
      <AlertErrors error={query.error} />
      {!query.isError && (
        <Table
          data={query.data?.results}
          emptyText={
            query.isLoading ? (
              <Loader loading={true} />
            ) : (
              <div className="py-6 text-center">Nu sunt date disponibile</div>
            )
          }
          footer={
            pagination && query.data?.results?.length
              ? () => (
                  <Flex className="py-4 px-4" justify="flex-end">
                    <Pagination
                      pageSizeChoice={pageSizeChoice}
                      pagination={pagination}
                      data={query.data}
                    />
                  </Flex>
                )
              : undefined
          }
          rowKey="id"
          scroll={{ x: true }}
          {...tableProps}
        />
      )}
    </>
  );
};
